import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDashboardCounts, type DashboardCounts } from '../../services/api/dashboard';

const cards: { key: keyof DashboardCounts; labelKey: string; to: string }[] = [
  { key: 'albums', labelKey: 'admin.dashboardCards.albums', to: '/admin/music' },
  { key: 'pendingFanPosts', labelKey: 'admin.dashboardCards.pendingFanPosts', to: '/admin/fanwall' },
  { key: 'photoAlbums', labelKey: 'admin.dashboardCards.photoAlbums', to: '/admin/photos' },
  { key: 'videos', labelKey: 'admin.dashboardCards.videos', to: '/admin/videos' },
  { key: 'socialLinks', labelKey: 'admin.dashboardCards.socialLinks', to: '/admin/social' },
  { key: 'merchItems', labelKey: 'admin.dashboardCards.merchItems', to: '/admin/merch' },
];

export default function DashboardPage() {
  const { t } = useTranslation();
  const [counts, setCounts] = useState<DashboardCounts | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDashboardCounts()
      .then(setCounts)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-[var(--color-text-muted)]">{t('common.loading')}</p>;

  return (
    <div className="admin-page">
      <h1 className="admin-page__title">{t('admin.dashboard')}</h1>
      <p className="mb-6 text-[var(--color-text-muted)]">{t('admin.overview')}</p>
      <div className="admin-dashboard-cards">
        {cards.map(({ key, labelKey, to }) => (
          <Link key={key} to={to} className="admin-dashboard-card">
            <div className="admin-dashboard-card__value">{counts?.[key] ?? 0}</div>
            <div className="admin-dashboard-card__label">{t(labelKey)}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
